// extracted by mini-css-extract-plugin
module.exports = {"small":"Parallax_small__0k6jf","medium":"Parallax_medium__xfPlY","large":"Parallax_large__dlzjY","full-height":"Parallax_full-height__7qk5f","content":"Parallax_content__ZZH0R"};